export const config = {
  apiBase: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "http://localhost:5263",
  firebase: {
    apiKey: (import.meta.env.VITE_FIREBASE_API_KEY as string | undefined) ?? "fake-api-key",
    projectId: (import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined) ?? "carwash-dev",
    // Explicit URL wins; otherwise dev builds default to the compose emulator.
    authEmulatorUrl:
      (import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL as string | undefined) ??
      (import.meta.env.DEV ? "http://localhost:9099" : undefined),
  },
  turnstileSiteKey:
    (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ?? "1x00000000000000000000AA", // Cloudflare's always-pass test key
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "",
};
